var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.33 10.5a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.667 0M7.473 7.973a.625.625 0 0 1 .884 0l1.641 1.641 1.642-1.64a.625.625 0 1 1 .884.883l-1.642 1.641 1.642 1.642a.625.625 0 1 1-.884.884l-1.642-1.642-1.641 1.642a.625.625 0 1 1-.884-.884l1.641-1.642-1.64-1.641a.625.625 0 0 1 0-.884",
    clipRule: "evenodd"
  })));
};
export default SvgClose;